import interpolate from 'app/common/utils/interpolate';
import { type ChangeEvent, useCallback, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { cancel, ok } from '../../actions';
import { getDomainState } from '../../selectors';
import type { ConfirmHookProps } from './confirm';

export const useConfirm = (): ConfirmHookProps => {
  const {
    confirmText = '',
    message,
    open,
    title,
    hideCancel,
    type,
    okLabel = 'Confirm',
    cancelLabel = 'Cancel'
  } = useSelector(getDomainState);
  const dispatch = useDispatch();
  const [confirmTextValue, setConfirmTextValue] = useState('');

  const handleChangeConfirmText = useCallback((event: ChangeEvent<HTMLInputElement>) => {
    setConfirmTextValue(event.target.value);
  }, []);

  const handleConfirm = useCallback(() => {
    setConfirmTextValue('');
    dispatch(ok());
  }, [dispatch]);

  const handleCancel = useCallback(() => {
    setConfirmTextValue('');
    dispatch(cancel());
  }, [dispatch]);

  const interpolatedMessage = useMemo(() => {
    return interpolate(message, { confirmText });
  }, [message, confirmText]);

  const disableOk = useMemo(() => {
    return confirmText !== undefined && confirmText !== confirmTextValue;
  }, [confirmText, confirmTextValue]);

  return {
    open,
    title,
    hideCancel,
    confirmText,
    type,
    okLabel,
    cancelLabel,
    message: interpolatedMessage,
    disableOk,
    handleConfirm,
    handleCancel,
    handleChangeConfirmText
  };
};
